import { createBrowserRouter } from "react-router-dom";
import DefaultComponent from "../components/DefaultComponent";

import {
  Home,
  Report,
  Login,
  Sensor,
  SiteList,
  SystemsList,
} from "../view/index";

const routes = createBrowserRouter([
  // PUBLIC ROUTE (no layout)
  {
    path: "/login",
    element: <Login />,
  },

  // PROTECTED ROUTES (uses DefaultComponent layout)
  {
    path: "/",
    element: <DefaultComponent />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "report",
        element: <Report />,
      },
      {
        path: "sensor",
        element: <Sensor />,
      },
      {
        path: "site-list",
        element: <SiteList />,
      },
      {
        path: "system-list",
        element: <SystemsList />,
      },
    ],
    loader: async () => {
      return <div>Loading…</div>;
    },
    errorElement: <div>Error Loading the page</div>,
  },
]);

export default routes;
